import {useRouter} from 'next/router'
import type {ParsedUrlQuery} from 'querystring'

export default function useRouterQuery(): CL.Query {
  const router = useRouter()
  return simplifyQueryParams(router.query)
}

export function useStringQueryParameter(name: string): string | undefined {
  const {query} = useRouter()
  const value = query[name]
  return Array.isArray(value) ? value[0] : value
}

export function simplifyQueryParams(
  originalQuery: CL.IncomingQuery | ParsedUrlQuery
): CL.Query {
  const simplifiedQuery: CL.Query = {}
  for (let [key, value] of Object.entries(originalQuery)) {
    if (value) {
      simplifiedQuery[key] = Array.isArray(value) ? value[0] : value
    }
  }
  return simplifiedQuery
}
